<header class="background-header"> 
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="shared-plans-container" id="sharedPlansContainer">
        <section class="template-section-title row">
            <h1 class="col">Shared Plans</h1>
        </section>
        <section class="shared-plans-section">
            <section class="shared-plans-list">
                <div class="shared-plans" *ngFor="let sharedPlan of sharedPlansList;">
                    <app-shared-plan-summary>

                    </app-shared-plan-summary>
                </div>
            </section>
        </section>
    </section>
</section>